import * as React from 'react';
import { Col, Row } from 'antd';
import { observer } from 'mobx-react';
import { Prompt } from 'react-router';

import { TextView } from 'src/core/ui/text.view';
import { TabLanguageController } from 'src/core/ui/language/tab-language.controller';
import { CardController } from 'src/app/shared/card.controller';
import { HeaderView } from 'src/app/shared/header.view';

interface TaxFormViewProps extends ComponentViewProps<TaxItem> {
	title: string,
	save: () => void,
	cancel: () => void,
	model: TaxItem;
	mode: ControlMode;
	onModeChanged: (mode: ControlMode) => void;
	setBusy(isBusy: boolean);
	contextService: any;
}

@observer
export class TaxFormView extends React.Component<TaxFormViewProps, any> {
	constructor(props: any) {
		super(props);
	}

	render() {
		const model = this.props.model;
		if (model == null) {
			return null;
		}

		const mode = this.props.mode;
		const displayNames = model.dynamicProperties['displayName'];
		const array: TabLanguageModel[] = [{ title: 'Title', dynamicProperties: displayNames, required: true }];

		return (
			<div className="window window-normal">
				<Prompt
					when={this.props.contextService.isDirty}
					message={location => `If you go to ${location.pathname}, all changes will be lost. Are you sure you want to continue?`}
				/>
				<Row>
					<Col xs={24} lg={{ offset: 6, span: 12 }}>
						<Row>
							<Col xs={24}>
								<HeaderView
									title={this.props.title}
									mode={this.props.mode}
									onModeChanged={this.props.onModeChanged}
									save={this.props.save}
									cancel={this.props.cancel}
									contextService={this.props.contextService}
								/>
							</Col>
						</Row>
						<CardController
							mode={this.props.mode}
							icon="book"
							title="General information">
							<Row>
								<Col xs={24}>
									<TabLanguageController model={this.props.model}
										dynamicProperties={array}
										mode={mode}
										setBusy={this.props.setBusy}
										isRichTextBox={false}
									/>
								</Col>
								<Col xs={24}>
									<TextView
										required
										onGetErrorMessage={() => this.props.model.validate(false, 'percent')}
										mode={mode}
										label="Percent"
										value={model.percent}
										onChanged={newVal => {
											newVal = newVal != null ? parseFloat(newVal) : null;
											model.percent = newVal;
										}}
										suffix="%"
										format="percent"
									/>
								</Col>
							</Row>
						</CardController>
					</Col>
				</Row>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/taxes/form/tax-form.view.tsx